import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../../core/services/auth.service';

// ─── Favorites ───────────────────────────────────────────────────────────────

export interface FavoriteItem {
  createdAt: string;
  favoriteId: string;
  type: string;
  itemId: string;
  title: string;
  slug: string;
  image: string;
  price: number;
  currency: string;
  priceType: string;
  bedrooms?: number;
  bathrooms?: number;
  area?: number;
  location: string;
  isFeatured: boolean;
  isTrusted: boolean;
}

export interface FavoritesResponse {
  success: boolean;
  results: number;
  data: FavoriteItem[];
}

// ─── Compare ─────────────────────────────────────────────────────────────────

export interface CompareUnit {
  id: string;
  title: string;
  image: string;
  price: { value: number; label: string };
  rating: { value: number; count: number };
  specs: {
    bedrooms: number;
    bathrooms: number;
    area: number;
    floor: number;
    adults?: number;
    children?: number;
  };
  status: { furnished: boolean; text: string; availability: string };
  location: string;
  features: { name: string }[];
  utilities?: (string | { name: string })[];
  financials?: { deposit?: number | null; commission?: Record<string, unknown> };
  yearBuilt: number | null;
}

export interface CompareResponse {
  success: boolean;
  data: CompareUnit[];
}

@Injectable({ providedIn: 'root' })
export class SeekerComparisonService {
  private baseUrl = environment.api.baseUrl;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) {}

  getFavorites(): Observable<FavoritesResponse> {
    return this.http.get<FavoritesResponse>(`${this.baseUrl}/seeker/favorites`, {
      headers: this.authHeaders(),
    });
  }

  compareUnits(unitIds: string[]): Observable<CompareResponse> {
    return this.http.post<CompareResponse>(
      `${this.baseUrl}/seeker/unit/compare`,
      { unitIds },
      { headers: this.authHeaders() },
    );
  }

  private authHeaders(): HttpHeaders | undefined {
    const token = this.authService.getAccessToken();
    return token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : undefined;
  }
}
